export default (value, footColorIntencity) => {
  const intensity = Math.floor((parseInt(value, 16) / 15) * 255) * footColorIntencity;

  return `rgb(${intensity}, ${intensity}, ${255 - intensity})`;
};
